module.exports = __webpack_public_path__ + "img/Flag_of_Haiti.94f11094.svg";